import React from 'react';

import { AlternateLink } from 'data/market/types';

// `en-us` and `en-gb` are relatively the most used locales
const prioHrefLangs = ['en-us', 'en-gb'];

interface AlternateLinkTagsProps {
  alternateLinks: AlternateLink[];
}

export default function AlternateLinkTags({ alternateLinks = [] }: AlternateLinkTagsProps) {
  const defaultAlternateLink = alternateLinks.find(({ hrefLang }) => prioHrefLangs.includes(hrefLang));

  return (
    <>
      {defaultAlternateLink && <link rel="alternate" hrefLang="x-default" href={defaultAlternateLink?.href} />}
      {alternateLinks.map(({ hrefLang, href }) => {
        return <link rel="alternate" hrefLang={hrefLang} href={href} key={hrefLang} />;
      })}
    </>
  );
}
